import { RouteConfig } from "vue-router";
import { RDocumentCard } from "./views/Card/RDocumentCard";
import { RDocumentCardArchivedFiles } from "./views/CardArchivedFiles/RDocumentCardArchivedFiles";

export const RDocument: RouteConfig = {
  path: ":document_id",
  name: "",
  component: () =>
    import(
      /* webpackChunkName: "employer-company-document" */
      "./VDocument.vue"
    ),
  meta: {
    label: "documents",
  },
  children: [RDocumentCard, RDocumentCardArchivedFiles],
};
